import React, {useEffect} from 'react'
import {SlotComponent} from '../../types/ui'
import {Box, Container, Stack, Text} from '../../vanilla'
import {Breadcrumbs} from '../breadcrumbs'
import {Slot} from './Slot'
import {Seo} from '../seo'
import {usePageDataTracking} from '../../analytics/page-tracking'
import { ContentPageType } from '../../types/cms/navigation'
import { SLOT_SCHEMAS } from './utils'

export const ContentPage: SlotComponent<ContentPageType> = ({content}) => {
  const sendPageData = usePageDataTracking()
  useEffect(() => {
    if (content && content?.slotContent) {
      sendPageData(pageType, pageCategory)
    }
  }, []);

  if (!content || !content?.slotContent) {
    return null
  }
  const {BreadCrumb, pageHeading, slotContent, backgroundColor} = content

  const heroContent = slotContent.find(
    ({_meta}) =>
      _meta?.schema === SLOT_SCHEMAS.CONTENT_HERO_SLOT || _meta.schema === SLOT_SCHEMAS.LANDING_HERO,
  )

  const bodyContent = slotContent.filter(
    ({_meta}) =>
      _meta?.schema === SLOT_SCHEMAS.CONTENT_SLOT || _meta?.schema === SLOT_SCHEMAS.LANDING_BODY,
  )
  
  const pageType = 'content'
  const pageCategory = 'Landing'

  return (
    <Box paddingBottom="20px">
      <Seo title={content?.SEO?.pageTitle} description={content?.SEO?.pageDescription} />
      <Container
        style={{backgroundColor: backgroundColor?.color || 'transparent'}}
        padding={backgroundColor?.name === 'White' ? '24px' : '0px'}
        paddingBottom={backgroundColor?.name === 'White' ? '40px' : '0px'}
      >
        {BreadCrumb && (
          <Box paddingY="12px">
            <Breadcrumbs
              breadcrumbs={BreadCrumb.map(({crumbText, crumbCtaLink}) => ({
                id: crumbText.toUpperCase(),
                name: crumbText,
                url: crumbCtaLink,
              }))}
            />
          </Box>
        )}
        {heroContent && <Slot data={heroContent} />}
        {(pageHeading?.heading || pageHeading?.heading2) && (
          <Box marginTop={['0px', '8px']} marginBottom={['24px', '36px']}>
            {pageHeading?.heading && (
              <Text
                variant="heading5"
                lineHeight="normal"
                textAlign={pageHeading?.textAlignment.toLowerCase() as 'left' | 'right' | 'center'}
                color="accent0"
              >
                {pageHeading.heading}
              </Text>
            )}
            {pageHeading?.heading2 && (
              <Text
                variant="heading1"
                textAlign={pageHeading?.textAlignment.toLowerCase() as 'left' | 'right' | 'center'}
              >
                {pageHeading.heading2}
              </Text>
            )}
          </Box>
        )}
        {bodyContent?.length ? (
          <Stack spacing={['16px', '24px']}>
            {bodyContent?.map((content) => {
              return content && <Slot data={content} />
            })}
          </Stack>
        ) : null}
      </Container>
    </Box>
  )
}
